import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ClaimToolAssociatedImagePayload } from '@shared/models/claim-tool-associated-image';
import { AssocImagesRequest } from '@shared/models/assoc-images-request';
import { AssocImageOption } from '@shared/models/associated-image.model';
import { ClaimToolElementSaveChangesData } from '@shared/models/claim-tool-element-save-changes-data.model';
import { ClaimToolElement } from '@shared/models/claim-tool-element.model';
import { AssociatedImage } from '@shared/models/common';
import { NgRedux } from '@shared/redux/redux-compatibility.service';
import { AppState } from '@shared/redux/store';
import { CatService } from '@shared/services/cat.service';
import { ClaimToolService } from '@shared/services/claim-tool.service';

@Component({
    selector: 'doc-assoc-images-options',
    templateUrl: './doc-assoc-images-options.component.html',
    styleUrl: './doc-assoc-images-options.component.scss',
    standalone: false
})
export class DocAssocImagesOptionsComponent {
  
  @Input() assocImagesRequest: AssocImagesRequest;
  @Input() disabled: boolean = false;

  loading: boolean;
  displayGenAi: boolean = false;
  assocImagesOptions: AssocImageOption[] = [];
  filterValue: string = 'not_associated_by_other';
  displayAssocImages: AssocImageOption[] = [];
  @Output() hasOptionsChange = new EventEmitter<boolean>();


  constructor(
    private claimToolService: ClaimToolService, 
    private catService: CatService,
    private ngRedux: NgRedux<AppState>
  ) {}

  get claimToolElement(): ClaimToolElement {
    return this.ngRedux.getState().claimToolElement;
  }

  get claimToolSaveChangesDataInitialValues(): ClaimToolElementSaveChangesData {
    return this.ngRedux.getState().claimToolSaveChangesDataInitialValues;
  }

  ngOnInit(): void {
    this.loading = true;
    this.assocImagesOptions = [];
    this.catService.getAssocImagesOptions(this.assocImagesRequest).subscribe(
      (assocImagesOptions) => {
        this.assocImagesOptions = assocImagesOptions;
        if (this.assocImagesOptions.length > 0) {
          this.displayGenAi = this.assocImagesOptions[0].display_genai;
        }
        const hasOptions = this.assocImagesOptions && this.assocImagesOptions.length > 0;
        this.hasOptionsChange.emit(hasOptions);
        this.loading = false;
        this.setAssociationsStatus();
        this.displayAssocImages = this.assocImagesOptions?.filter(assocImageOption => !assocImageOption.associated_by_others) || [];
      },
      () => (this.loading = false) 
    )
  }

  setAssociationsStatus() {
    this.claimToolElement.associatedImages = [];    
    let associatedImages = [];
    for(let i=0; i<this.assocImagesOptions.length; i++) {
      
      let imageToAdd = this.assocImagesOptions[i];
      let assocImage = {} as ClaimToolAssociatedImagePayload

      if (imageToAdd.is_associated) {
        
        assocImage.image_id = imageToAdd.image_id;
        //assocImage.phraseId = this.claimToolElement.phraseId;
        // assocImage.assocPhraseText = phraseToAdd.phrase_text;
        associatedImages.push(assocImage);
      }
    }

    this.claimToolElement.associatedImages = associatedImages;
    this.claimToolSaveChangesDataInitialValues.associatedImages = JSON.parse(JSON.stringify(associatedImages));  
  }

  add(assocImageOption: AssocImageOption, deAssocOthers: boolean = false) {
    if (this.disabled) {
      return;
    }
    
    assocImageOption.is_associated = true;

    let idx = this.claimToolElement.deletedAssociatedImages.findIndex(
      (r) => r.image_id == assocImageOption.image_id
    );

    if (idx != -1) {
      this.claimToolElement.deletedAssociatedImages.splice(idx, 1);
    }

    let assocImage =  {} as ClaimToolAssociatedImagePayload;
    assocImage.image_id = assocImageOption.image_id;
    assocImage.de_assoc_others = deAssocOthers;
    this.claimToolElement.associatedImages.push(assocImage);
    this.claimToolService.manageAssocImagesChanged$.next(this.compareWithInitialArray());  
  }
  
  remove(assocImageOption: AssocImageOption) {
    if (this.disabled) {
      return;
    }

    assocImageOption.is_associated = false;

    let idx = this.claimToolElement.associatedImages.findIndex(
      (r) => r.image_id == assocImageOption.image_id
    );

    if (idx != -1) {
      const removedAssocImage = this.claimToolElement.associatedImages[idx];
      //removedAssocText.deleteSw = true;
      this.claimToolElement.deletedAssociatedImages.push(removedAssocImage);
      this.claimToolElement.associatedImages.splice(idx, 1);
      this.claimToolService.manageAssocImagesChanged$.next(this.compareWithInitialArray());
    }
  }
    onFilterChange() {
      if (this.filterValue == 'all') {
        this.displayAssocImages = this.assocImagesOptions;
        return;
      }
        this.displayAssocImages = this.assocImagesOptions.filter(assocImageOption => !assocImageOption.associated_by_others);
    }
  
  canRemoveAssocImage(assocImageOption: AssocImageOption): boolean {
    return assocImageOption.is_associated;
  }
  canAddAssocImage(assocImageOption: AssocImageOption): boolean {
    return !assocImageOption.is_associated;
  }
  canDeAssociateImage(assocImageOption: AssocImageOption): boolean {
    return !assocImageOption.initially_associated && assocImageOption.associated_by_others;

  }

  private compareWithInitialArray(): boolean {

    const initialAssociations = this.claimToolSaveChangesDataInitialValues.associatedImages;
    const currAssociations = this.claimToolElement.associatedImages;

    if (currAssociations.length != initialAssociations.length) {
      // associations deleted 
      // associations added  
      return true;
    }
    // same length
    // reference added and reference deleted
    // we need to check if reference is added that werent in array
    for (let i = 0; i < currAssociations.length; i++) {
      const currAssociation = currAssociations[i];
      const foundAssociation = initialAssociations.findIndex(association => currAssociation.image_id == association.image_id);

      if (foundAssociation == -1) {
        // added reference
        // not in initial references
        return true;
      }
    }

    return false;
  }

}
